<template>
  <div class="orderList">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部订单" name="first">
        <div class="card_block">
          <div
            class="card_item"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div class="form">
              <span class="label">订单编号：</span>{{ item.order_no }}
            </div>
            <div class="form">
              <span class="label">设备编号：</span>{{ item.equipment_no }}
            </div>
            <div class="form">
              <span class="label">下单时间：</span>{{ item.succ_pay_time }}
            </div>
            <div class="form last">
              <span class="des1">实付</span>
              <span class="money">￥{{ item.money }}</span>
            </div>
          </div>
        </div></el-tab-pane
      >
      <el-tab-pane label="使用中" name="second">
        <div class="card_block">
          <div
            class="card_item"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div class="form">
              <span class="label">订单编号：</span>{{ item.order_no }}
            </div>
            <div class="form">
              <span class="label">设备编号：</span>{{ item.equipment_no }}
            </div>
            <div class="form">
              <span class="label">下单时间：</span>{{ item.succ_pay_time }}
            </div>
            <div class="form last">
              <span class="des1">实付</span>
              <span class="money">￥{{ item.money }}</span>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="申请退款" name="third">
        <div class="card_block">
          <div
            class="card_item card_item_pro"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div class="progress">
              <el-progress
                :show-text="false"
                :stroke-width="10"
                :width="160"
                type="circle"
                :percentage="item.percent || 0"
                color="#23C2C0"
                define-back-color="#9AE8E6"
              >
              </el-progress>
              <div class="time_cnt">
                <div class="des1">剩余</div>
                <div class="time">{{ item.time || "00:00:00" }}</div>
                <div class="des2">时/分/秒</div>
              </div>
            </div>

            <div class="form_cnt">
              <div class="form">
                <span class="label">订单编号：</span>{{ item.order_no }}
              </div>
              <div class="form">
                <span class="label">设备编号：</span>{{ item.equipment_no }}
              </div>
              <div class="form line">
                <span class="label">订单金额：</span>
                <div>
                  <span class="des1">实付</span>
                  <span class="money">￥{{ item.money }}</span>
                </div>
              </div>
              <div class="form last1" @click="handleDialog1(item)">
                <div class="refude_btn">申请退款</div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 提示的弹窗1 -->
    <div class="dialog1" v-show="isShowDialog1">
      <div class="diaMain">
        <img
          class="dialog1_bg"
          src="@/assets/adule_img/btnList/dialog1_bg.png"
          alt=""
        />
        <img
          class="money_icon"
          src="@/assets/adule_img/btnList/money_icon.png"
          alt=""
        />
        <div class="title">—申请退款—</div>
        <div class="cnt">非设备故障问题不可申请退款</div>
        <!-- 打开退款弹窗 -->
        <div class="btn btn1" @click="isShowDialog1 = false">取消</div>
        <div class="btn" @click="handleApplyRefund">确定</div>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      custom-class="dialogMessage"
      :show-close="false"
    >
      <el-form ref="form" :model="form" inline :rules="rules">
        <el-form-item label="联系人" prop="name">
          <el-input v-model="form.name" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="contact">
          <el-input
            v-model="form.contact"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请内容" prop="re_mark">
          <el-input
            v-model="form.re_mark"
            placeholder="请输入申请内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "WorkspaceJsonOrderList",

  data() {
    return {
      activeName: "first",
      // 订单列表
      orderList: [
        // {
        //   equipment_no: "861538074454478",
        //   id: 3907410,
        //   money: 0.01,
        //   order_no: "20258178448658199800",
        //   order_state: 2,
        //   order_type: 1,
        //   project_no: "A250701000",
        //   succ_pay_time: "2025-08-01 14:55:12",
        //   remain_seconds: 120, // 剩余时间，单位秒
        //   all_time: 3600, // 总时长，单位秒
        // },
      ],
      time: "", // 时间戳
      timer: null, // 定时器
      remainingSeconds: "",
      isShowDialog1: false, //打开弹窗1
      dialogVisible2: false, //打开弹窗2
      itemObj: {},
      form: {
        name: "", //联系人
        contact: "", // 手机号
        re_mark: "", // 申请内容
      },
      rules: {
        name: [{ required: true, trigger: "blur", message: "请输入联系人" }],
        contact: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        re_mark: [
          { required: true, trigger: "blur", message: "请输入申请内容" },
        ],
      },
      timers: {}, // 存储每个订单的定时器
      percent: 0, // 进度条百分比
      remainingTimes: {}, // 存储每个订单的剩余时间(秒)
      allTimes: {}, // 存储每个订单的总时长(秒)
    };
  },

  mounted() {
    this.getList();
  },

  beforeDestroy() {
    // 清除所有定时器
    Object.keys(this.timers).forEach((id) => {
      clearInterval(this.timers[id]);
      this.$delete(this.timers, id);
    });
  },
  methods: {
    handleClick() {
      if (this.activeName == "first") {
        this.getList();
      } else if (this.activeName == "second") {
        this.getList2();
      } else if (this.activeName == "third") {
        this.getList2();
      }
    },
    // 全部订单  https://htapi.zxznzy.com
    // || "ovA4QwV_eRGr6CkA1VEjathmNwx8"
    getList() {
      axios({
        method: "get",
        url: "https://htapi.zxznzy.com/project/adult_h5_order_list",
        params: {
          open_id:
            localStorage.getItem("open_id") || "ovA4QwV_eRGr6CkA1VEjathmNwx8", // 用户open_id
        },
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.orderList = res.data.data.order_list; // 更新订单列表
          } else {
            this.$message.error("获取订单列表失败：" + res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    // 运行中的订单
    getList2() {
      axios({
        method: "get",
        url: "https://htapi.zxznzy.com/project/adult_h5_order_running",
        params: {
          open_id:
            localStorage.getItem("open_id") || "ovA4QwV_eRGr6CkA1VEjathmNwx8",
        },
      })
        .then((res) => {
          if (res.data.code == 1) {
            // 使用模拟数据或真实数据
            this.orderList = res.data.data.item.map((item) => ({
              ...item,
              percent: 0,
              time: "00:00:00",
            }));

            // 为每个订单启动倒计时
            this.orderList.forEach((item) => {
              this.startCountdown(
                item.id,
                item.ttl_times.ttl || 0,
                item.mark || 0
              );
            });
          } else {
            this.$message.error("获取订单列表失败：" + res.data.message);
          }
        })
        .catch(() => {
          this.$message.error("获取订单列表失败");
        });
    },
    // 启动倒计时
    startCountdown(orderId, seconds, allTime) {
      // 清除已有定时器
      if (this.timers[orderId]) {
        clearInterval(this.timers[orderId]);
        this.$delete(this.timers, orderId);
      }

      // 初始化时间数据
      this.$set(this.remainingTimes, orderId, seconds);
      this.$set(this.allTimes, orderId, allTime);

      // 立即更新首次进度
      this.updateProgress(orderId);

      // 启动新定时器
      this.timers[orderId] = setInterval(() => {
        if (this.remainingTimes[orderId] <= 0) {
          clearInterval(this.timers[orderId]);
          this.$delete(this.remainingTimes, orderId);
          this.updateProgress(orderId); // 最终更新为0
          this.$message.success(`订单${orderId}体验时间已结束`);
        } else {
          this.remainingTimes[orderId]--;
          this.updateProgress(orderId);
        }
      }, 1000);
    },
    // 更新进度条百分比和时间显示
    updateProgress(orderId) {
      const index = this.orderList.findIndex((item) => item.id === orderId);
      if (index > -1) {
        const remaining = this.remainingTimes[orderId] || 0;
        const total = this.allTimes[orderId] || 3600;
        const percent = Math.round((remaining / total) * 100);

        // 使用Vue.set确保响应式更新
        this.$set(this.orderList, index, {
          ...this.orderList[index],
          percent: Math.max(0, Math.min(100, percent)),
          time: this.secondsToHMS(remaining),
        });
      }
    },

    // 秒数转HH:MM:SS
    secondsToHMS(seconds) {
      const pad = (num) => num.toString().padStart(2, "0");
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
    },
    updateTime() {
      if (this.remainingSeconds <= 0) {
        clearInterval(this.timer);
        this.time = "00:00:00";
        // this.$message.success("体验时间已结束");
        return;
      }
      this.time = this.secondsToHMS(this.remainingSeconds--);
    },
    // 打开弹窗的提示1
    handleDialog1(item) {
      this.itemObj = item; // 保存当前订单信息
      this.isShowDialog1 = true;
    },

    //点击申请退款，打开弹窗
    handleApplyRefund() {
      this.form = {
        name: "", //联系人
        contact: "", // 手机号
        re_mark: "", // 申请内容
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.isShowDialog1 = false;
      this.dialogVisible2 = true;
    },
    // 申请退款的确定
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          axios({
            method: "post",
            url: "https://htapi.zxznzy.com/project/wx_refund_back",
            data: {
              order_no: this.itemObj.order_no,
              open_id:
                localStorage.getItem("open_id") ||
                "ovA4QwV_eRGr6CkA1VEjathmNwx8", // 用户open_id
              ...this.form,
            },
          })
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success("申请退款成功");
                this.dialogVisible = false;
              } else {
                this.$message.error("获取订单列表失败：" + res.data.message);
              }
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
              this.dialogVisible = false;
            });
        }
      });
    },
    // 跳转到详情
    handleDetail(item) {
      this.$router.push({
        path: "/orderDetail",
        query: {
          order_id: item.id,
          order_no: item.order_no,
          equipment_no: item.equipment_no,
          money: item.money,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.orderList {
  background: linear-gradient(to bottom, #c1f7f5, #fff);
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 30px 0;
  box-sizing: border-box;

  .card_block {
    width: 100%;
    max-height: 90vh;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
  }
  .card_item {
    border-radius: 10px;
    width: 100%;
    padding-left: 15px;
    margin-top: 10px;
    box-sizing: border-box;
    background: #fff;

    .form {
      margin: 10px 0;
      border-bottom: 1px solid #e8e8e8;
      padding-bottom: 10px;
      box-sizing: border-box;
      .des1 {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 12px;
        color: #010101;
        margin-right: 2px;
      }
      .money {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 17px;
        color: #23c2c0;
      }
      .label {
        background: #23c2c0;
        color: #fff;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        padding: 0 0px 0 8px;
        margin-right: 10px;
      }
    }
    .form.last {
      border-bottom: none;
      text-align: right;
      padding-right: 15px;
    }
    .form.line {
      display: flex;
      justify-content: space-between;
      padding-right: 15px;
    }
    .form.last1 {
      display: flex;
      align-items: center;
      justify-content: right;
      border-bottom: none;
      text-align: right;
      padding-right: 10px;
    }
    .refude_btn {
      color: #fff;
      background: #4dcbc9;
      border-radius: 10px;
      padding: 4px 10px;
      font-size: 14px;
    }
  }
  .card_item:last-child {
    margin-bottom: 10px;
  }
  .card_item_pro {
    background: none;
    padding-left: 0;
    .progress {
      text-align: center;
      position: relative;
      .time_cnt {
        position: absolute;
        top: 32px;
        left: 33vw;
        .des1 {
          color: #23c2c0;
          font-size: 24px;
          font-weight: bold;
        }
        .time {
          color: #23c2c0;
          font-size: 24px;
          margin: 10px 0;
        }
        .des2 {
          color: #bad8d8;
        }
      }
    }
    .form_cnt {
      padding-left: 15px;
      background: #fff;
      .form {
        padding-top: 10px;
      }
    }
  }
  .dialog1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(128, 128, 128, 0.5);
    .diaMain {
      width: 90vw;
      position: absolute;
      top: 40vh;
      left: 8vw;
      z-index: 2;
      border-radius: 20rpx;

      .dialog1_bg {
        width: 90vw;
        height: 34vh;
      }
      .money_icon {
        width: 22vw;
        position: absolute;
        z-index: 2;
        right: 1vw;
      }
      .title {
        position: absolute;
        z-index: 2;
        right: 30vw;
        top: 3vh;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 23px;
        color: #353636;
      }
      .cnt {
        position: absolute;
        z-index: 2;
        right: 13vw;
        top: 14vh;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 18px;
        color: #353636;
        font-weight: bold;
      }
      .btn.btn1 {
        position: absolute;
        z-index: 2;
        top: 22vh;
        left: 12vw;
        background: #a5bcbb;
      }
      .btn {
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #ffffff;
        background: #27a8a6;
        position: absolute;
        z-index: 2;
        top: 22vh;
        left: 50vw;
        width: 107px;
        height: 4.5vh;
        text-align: center;
        line-height: 4.5vh;
        border-radius: 6px;
      }
    }
  }
}
::v-deep {
  .el-tabs__header.is-top {
    width: 90vw;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .el-tabs__item.is-active {
    color: #23c2c0;
  }
}
::v-deep {
  .el-dialog__body {
    padding: 30px 0 !important;
  }
  .dialogMessage {
    margin-top: 20vh !important;
    width: 90% !important;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      box-sizing: border-box;
      letter-spacing: 2px;
    }
  }
}
</style>
